<template>
  <base-layout>
    <template>
      <div class="row">
        <div class="col-md-1" style="margin-left:60px;margin-right: 66px;">
        </div>
        <div class="col-md-8">
          <h3 style="color:#192247;font-weight: 600;">{{TabTitle}}</h3>
        </div>
      </div>
      <ob-layout :type="12">
        <template slot="left-section">
          <div class="leave-mgmt">
            <li class="vertical-tab leave-count" :class="{'active-tab': $route.name == 'leave-management' }">
              <span style="margin-left: 10px;"> <router-link :to="{name:'leave-management'}"><span>Apply Leave</span> </router-link></span>
            </li>
            <li class="vertical-tab" :class="{'active-tab': $route.name == 'leave-count' }" >
              <span style="margin-left: 10px;"> <router-link :to="{name:'leave-count'}"><span>Leave Count</span> </router-link></span>
            </li>
            <li class="vertical-tab" :class="{'active-tab': $route.name == 'leave-history' }">
              <span style="margin-left: 10px;"> <router-link :to="{name:'leave-history'}"><span>Leave History</span> </router-link></span>
            </li>
            <li class="vertical-tab" :class="{'active-tab': $route.name == 'leave-policy' }">
              <span style="margin-left: 10px;"> <router-link :to="{name:'leave-policy'}"><span>Leave Policy</span> </router-link></span>
            </li>
            <li class="vertical-tab" :class="{'active-tab': $route.name == 'holiday-list' }">
              <span style="margin-left: 10px;"> <router-link :to="{name:'holiday-list'}"><span>Holiday List</span> </router-link></span>
            </li>
          </div>
        </template>
        <template slot="right-section">
          <router-view></router-view>
        </template>
      </ob-layout>
    </template>
  </base-layout>
</template>
<script>
export default {
  data(){
    return{
    }
  },
  components: {

  },
  computed: {
    TabTitle()
    {
      if(this.$route.name == 'leave-management')
      {
        return 'Apply Leave'
      }
      else if(this.$route.name == 'leave-count')
      {
        return 'Leave Count'
      }
      else if(this.$route.name == 'leave-history' )
      {
        return 'Leave History'
      }
      else if(this.$route.name == 'leave-policy')
      {
        return 'Leave Policy'
      }
      else if(this. $route.name == 'holiday-list' )
      {
        return 'Holiday List'
      }
    },
  },
  methods:{
    addTask(){
      this.openAddTaskPopup = true
    },
  },
}
</script>
<style lang="scss" scoped>
  .tasks_empty{
    margin-top: 14%;
    text-align: center;
    vertical-align: middle;
  }
  .left_view{
    background-color:white;
    margin-top:10px;
    margin-left:20px;
    margin-right:10px;
    width: 140px;
  }
  .right_view{
    background-color:white;
    height:100%;
    margin-top:10px;
  }
  .leave-mgmt{
    .vertical-tab{
      list-style-type: none;
      font-weight: 600;
      cursor: pointer;
      padding:14px;
      a{
        color:#000000;
      }
    }
    .vertical-tab.active-tab {
      background: #f0f7ff;
      border-left: 3px solid #59a2e7;
      a{
        color: #337ab7 !important;
      }
    }
  }
  .leave-count{
    margin-top: 8px;
    /* margin-bottom:12px !important; */
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Leavemanagement.vue